import { type Logout } from 'chat-web';
import { nodeApiClient, type NodeApiClientResponse, routes } from '../';

export const nodeApiLogout = async () => {
  return nodeApiClient.post<NodeApiClientResponse<Logout>>(routes.user.logout);
};
